module.exports = __webpack_public_path__ + "img/no-data.b8bcc919.png";